var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app',[_c('c-detail',[_c('c-detail-item',{attrs:{"label":"app"}},[_vm._v(" "+_vm._s(_vm.$store.state.app)+" ")]),_c('c-detail-item',{attrs:{"label":"userInfo"}},[_vm._v(" "+_vm._s(_vm.$store.state.userInfo)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }